import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import React, {useEffect, useState} from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: 300,
    borderRadius: theme.spacing(2),
  },
  noBottomRadius: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textAlign: 'center',
  },
  dialogContentRoot: {
    padding: theme.spacing(2, 4),
  },
  progress: {
    transform: 'scaleX(-1)',
  },
}));

export default React.memo(function FancyDialog({
  title,
  content,
  actions = [],
  seconds,
  ...props
}) {
  const classes = useStyles();

  const [remainSeconds, setRemainSeconds] = useState(seconds);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRemainSeconds((remainSeconds) => {
        if (remainSeconds > 0) {
          return remainSeconds - 1;
        }
        return 0;
      });
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [remainSeconds]);

  return (
    <Dialog
      classes={{
        paper: clsx(
          (!!title || !!actions?.length) && classes.dialogPaper,
          !!seconds && classes.noBottomRadius,
        ),
      }}
      {...props}
    >
      {!!title && <DialogTitle className={classes.title}>{title}</DialogTitle>}

      {!!content && (
        <DialogContent classes={{root: classes.dialogContentRoot}}>
          {typeof content === 'string' || content instanceof String ? (
            <DialogContentText>{content}</DialogContentText>
          ) : (
            content
          )}
        </DialogContent>
      )}
      {!!actions.length && (
        <DialogActions>
          {actions.map((action, index) => (
            <React.Fragment key={index}>{action}</React.Fragment>
          ))}
        </DialogActions>
      )}
      {!!seconds && (
        <LinearProgress
          variant="determinate"
          value={(1 - remainSeconds / seconds) * 100}
          className={classes.progress}
        />
      )}
    </Dialog>
  );
});
